<h5 class="request-type">
  {{ 'common.requestType.' | transloco }}:
  {{ 'common.requestType.' + requestType() | transloco }}
</h5>
